<template>
  <div class="tw-w-full tw-flex tw-flex-col">
    <div class="tw-flex tw-items-center tw-justify-between tw-py-3 tw-px-4">
      <span class="tw-text-base tw-text-textMain tw-font-bold">{{
        $t("全部产品")
      }}</span>
      <b-dropdown
        variant="link"
        toggle-class="text-decoration-none"
        :text="activeName"
      >
        <b-dropdown-item
          v-for="item in navItems"
          :key="item.id"
          @click="handleClick(item)"
          >{{ displayCategoryName(item) }}</b-dropdown-item
        >
      </b-dropdown>
    </div>
    <div class="tw-flex tw-flex-col">
      <b-row
        class="tw-mb-4"
        v-for="(item, index) in productMap[activeId]"
        :key="index"
      >
        <b-col :cols="12">
          <div
            class="tw-flex tw-items-center tw-pl-4 tw-cursor-pointer tw-bg-bgMain tw-py-2"
            @click="handleItemClick(item)"
          >
            <span class="tw-text-sm tw-text-textInfo">{{
              displayCategoryName(item)
            }}</span>
            <b-icon
              icon="chevron-right"
              class="tw-w-3 tw-h-3 tw-ml-0.5"
              style="color: #333"
            ></b-icon>
          </div>
        </b-col>
        <b-col
          :cols="12"
          v-for="(child, index2) in item.products"
          :key="index2"
        >
          <MobileSelectItem
            :item="child"
            @onSelect="handleToProductDetail"
            :isShowIcon="false"
            :isShowDesc="false"
          />
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<script>
import { productsApi, navProductsApi, categoriesApi } from "@/api/modules/home";
import MobileSelectItem from "./components/MobileSelectItem.vue";
import { getCategoryDisplayName } from "@/utils/category";
export default {
  name: "MobileProductMenu",
  components: {
    MobileSelectItem,
  },
  data() {
    return {
      navItems: [],
      activeId: -1,
      listquery: {
        pageIndex: 1,
        pageSize: 8,
        categoryId: "",
      },
      productMap: {},
      productSearchValue: "",
      productSearchList: [],
    };
  },
  computed: {
    activeName() {
      return this.displayCategoryName(
        this.navItems.find((item) => item.id == this.activeId),
      );
    },
  },
  mounted() {
    this.getCategories();
  },
  methods: {
    displayCategoryName(category) {
      const name = getCategoryDisplayName(category, this.$i18n.locale);
      return name && this.$te(name) ? this.$t(name) : name;
    },
    // 获取产品分类列表
    async getCategories() {
      const indexInfo = localStorage.getItem("indexInfo");
      const cate = indexInfo ? JSON.parse(indexInfo).categoryTree : [];
      if (cate.length) {
        this.navItems = cate;
      } else {
        // 获取产品分类列表
        const res = await categoriesApi();
        if (res && res.data && res.data.length) {
          this.navItems = res.data;
        }
      }
      this.navItems.unshift({
        id: -1, // 做推荐的临时id
        name: this.$t("推荐产品"),
      });
      this.handleClick(this.navItems[0]);
    },
    handleClickAllProduct() {
      this.$emit("handleToDetail", null);
      this.$router.push("/product");
    },
    handleClick(item) {
      this.activeId = item.id;
      if (item.id === -1) {
        this.listquery.categoryId = "";
        this.listquery.isRecommend = 1;
      } else {
        this.listquery.categoryId = item.id;
        this.listquery.isRecommend = "";
      }
      this.listquery.pageIndex = 1;
      this.listquery.pageSize = 20;
      this.getProducts();
    },
    getProducts() {

      if (this.productMap[this.activeId]) {
        return;
      }
      if (this.activeId !== -1) {
        navProductsApi(this.listquery).then((res) => {
          if (res && res.data) {
            this.$set(this.productMap, this.activeId, res.data);
          }
        });
      } else {
        productsApi(this.listquery).then((res) => {
          if (res && res.data) {
            this.$set(this.productMap, this.activeId, [
              {
                categoryId: this.activeId,
                categoryName: this.$t("推荐产品"),
                products: res.data.list || [],
              },
            ]);
          }
        });
      }
    },
    handleToProductDetail(item) {
      this.productSearchValue = "";
      localStorage.setItem("detailForm", JSON.stringify(item));
      this.$emit("handleToDetail", item);
      // 如果是审计分类 跳单次服务页
      if (item.categoryId === 90) {
        this.$router.push(`/single-product/${item.id}?isApi=false`);
      } else {
        this.$router.push(`/product/${item.id}?isApi=false`);
      }
    },
    handleItemClick(item) {
      this.$emit("handleToDetail", null);
      if (item.categoryId === -1) {
        this.$router.push("/product");
      } else {
        this.$router.push({
          name: "product",
          query: { categoryId: item.categoryId },
        });
      }
    },
    handleSearch() {
      productsApi({
        pageIndex: 1,
        pageSize: 100,
        searchWord: this.productSearchValue,
      }).then((res) => {
        if (res && res.data && res.data.list) {
          this.productSearchList = res.data.list;
        }
      });
    },
    handleCloseSearch() {
      this.productSearchValue = "";
      this.productSearchList = [];
    },
  },
};
</script>
<style lang="scss" scoped></style>
